import React, { FunctionComponent } from 'react';
import { Eyebrow, ShepherdLensLogo, Text, TextLink } from '@companion-professional/components';

// LoginSplash is the section of the login page that includes the logo, name, and some links.  The decorative arch and
// circle echo the geometric fill shapes from the Shepherd brand guide.
export const LoginSplash: FunctionComponent = () => {
  return (
    <div className="relative overflow-hidden bg-nav p-6 py-8 text-on-nav md:flex md:w-80 md:flex-shrink-0 md:flex-col md:items-center md:justify-evenly">
      <div aria-hidden className="absolute -bottom-16 -left-10 h-40 w-40 rounded-t-full bg-primary" />
      <div aria-hidden className="absolute -right-6 -top-6 h-16 w-16 rounded-full bg-brand-green" />
      <div className="relative my-3 flex flex-col items-center justify-center gap-3">
        <ShepherdLensLogo inverted size="lg" stacked />
        <Eyebrow tone="inherit" className="text-brand-sky">
          Built for vets, by vets
        </Eyebrow>
      </div>
      {/* TODO: Create terms and conditions pages (when/if needed) or remove this links  This could also be a good
                place for signup and demo links */}
      <Text size="sm" className="relative mt-6 text-center text-on-nav/70">
        Read our{' '}
        <TextLink tone="inherit" href="#">
          terms
        </TextLink>{' '}
        and{' '}
        <TextLink tone="inherit" href="#">
          conditions
        </TextLink>
      </Text>
    </div>
  );
};
